const SocketResponseState = require("../redux/actions/socket").SocketResponseState;
const io = require("socket.io-client");
const Socket = (function () {
  let instance;
  function createInstance(userId) {
    console.log("==== userId ====", userId);
    const socket = io(process.env.REACT_APP_ROOT_URL, {
      withCredentials: true,
      query: {
        clientId: userId,
        from: "admin",
      },
    });
    socket.on("connect", function (err, data) {
      console.log("========= socket ============ Connection Created", err, data);
    });

    socket.on("newActivityCreated", function (data) {
      SocketResponseState("newActivityCreated", data);
    });

    socket.on("refreshDashboard", function (data) {
      SocketResponseState("RefreshDashboard", data);
    });
    socket.on("newAuction", function (data) {
      SocketResponseState("NewAuctionCreated", { record: 1 });
      SocketResponseState("AddRecord", data, "forApprovalAuctionList");
    });
    socket.on("closeAuctions", function (data) {
      console.log("======Socket function call =====", data);
      SocketResponseState("SomeAuctionsClosed", data);
    });

    function onConnect(userId) {
      return new Promise((resolve, reject) => {
        socket.emit("connect", { id: userId });
        resolve();
      });
    }

    function socketDisconnet() {
      return new Promise((resolve, reject) => {
        socket.emit("disconnect", {});
        resolve();
      });
    }
    return {
      onConnect,
      socketDisconnet,
    };
  }
  return {
    getInstance: function (userId) {
      if (!instance) {
        instance = createInstance(userId);
      }
      return instance;
    },
  };
})();
module.exports = {
  Socket: Socket,
};
